import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d5f5f2a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "row mt-3 align-items-center mb-1"
}
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "row mt-4 mb-3" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = {
  key: 1,
  class: "row align-items-center mb-1 padding-tb"
}
const _hoisted_6 = { class: "col-md-10 col-xs-12" }
const _hoisted_7 = { class: "col-xs-12 col-md-2" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = {
  class: "col-12",
  id: "personal"
}
const _hoisted_10 = {
  class: "col-12",
  id: "social"
}
const _hoisted_11 = {
  class: "col-12",
  id: "working"
}
const _hoisted_12 = { class: "row" }
const _hoisted_13 = {
  key: 0,
  class: "col-8"
}
const _hoisted_14 = {
  key: 0,
  class: "outer-file-list"
}
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "outer-file-list" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Projektzusammenarbeiten", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Legend = _resolveComponent("Legend")!
  const _component_CompareDialogue = _resolveComponent("CompareDialogue")!
  const _component_SkillTableAccordion = _resolveComponent("SkillTableAccordion")!
  const _component_EntwicklungsPlan = _resolveComponent("EntwicklungsPlan")!
  const _component_FileList = _resolveComponent("FileList")!
  const _component_Zusammenarbeit = _resolveComponent("Zusammenarbeit")!
  const _directive_hasperms = _resolveDirective("hasperms")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.type != 'personal' && !_ctx.simple)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.overviewHeader) + " Overview", 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Legend, {
          withTarget: _ctx.type == 'personal',
          horizontal: ""
        }, null, 8, ["withTarget"])
      ])
    ]),
    (_ctx.type != 'personal')
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h3", null, "Übersicht " + _toDisplayString(_ctx.tableHeader), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.compareClick && _ctx.compareClick(...args)))
            }, "Filter"),
            _createVNode(_component_CompareDialogue, {
              open: _ctx.compareOpen,
              onClose: _ctx.compareClose,
              type: _ctx.type,
              unit: _ctx.unit
            }, null, 8, ["open", "onClose", "type", "unit"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_SkillTableAccordion, {
          name: _ctx.name,
          skills: _ctx.personal,
          title: _ctx.$t('skills.personal'),
          type: _ctx.type,
          unit: _ctx.unit,
          group: "personal"
        }, null, 8, ["name", "skills", "title", "type", "unit"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_SkillTableAccordion, {
          name: _ctx.name,
          skills: _ctx.social,
          title: _ctx.$t('skills.social'),
          type: _ctx.type,
          unit: _ctx.unit,
          group: "social"
        }, null, 8, ["name", "skills", "title", "type", "unit"])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_SkillTableAccordion, {
          name: _ctx.name,
          skills: _ctx.working,
          title: _ctx.$t('skills.professional'),
          type: _ctx.type,
          unit: _ctx.unit,
          group: "working"
        }, null, 8, ["name", "skills", "title", "type", "unit"])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      (_ctx.type == 'personal')
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createVNode(_component_EntwicklungsPlan, { unit: _ctx.unit }, null, 8, ["unit"]),
            (_ctx.files.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  (_ctx.files.length > 0)
                    ? (_openBlock(), _createElementBlock("h3", _hoisted_15, "Dateien"))
                    : _createCommentVNode("", true),
                  (_ctx.files.length > 0)
                    ? (_openBlock(), _createBlock(_component_FileList, {
                        key: 1,
                        files: _ctx.files
                      }, null, 8, ["files"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_16, [
              _hoisted_17,
              _createVNode(_component_Zusammenarbeit, { user: _ctx.unit }, null, 8, ["user"])
            ])), [
              [_directive_hasperms, ['user.all.manage', 'user.unit.manage', 'user.allbutceo.manage']]
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["col-4", { 'offset-8': _ctx.type != 'personal' }])
      }, [
        _createVNode(_component_Legend, {
          withTarget: _ctx.type == 'personal',
          noheader: ""
        }, null, 8, ["withTarget"])
      ], 2)
    ]),
    _hoisted_18
  ], 64))
}